/* eslint-disable */
import WASMVisualiser from "./visualiser";
import { debounce } from "~/lib/debounce";
import { addListener } from "~/lib/signals";
import { _ } from "~/i18n";
import SceneProvider from "~/scene/provider";
import Scene from "~/scene";
import { store } from "~/state/store";
import { setCoordinates } from "~/state/map/state";
import { getIcon, getUserDataFromMapElement, getUserDataFromPoi, registerIcons } from "./utils";
import { getLocation } from "~/whereami";
import { description } from "~/util/providers/poiagg";

interface IModuleElem {
	elementId: number;
	elementUserData?: any;
}

export default class WASMProvider extends SceneProvider {
	_dom: any;

	_map: any;

	_content: any;

	_hoverEl: IModuleElem;

	_lastHoverEl: IModuleElem;

	_historyReplace: () => void;

	_updatePos: () => void;

	_mapClickListener: any;

	_dropClick: () => void;

	_binds: {[key: string]: (event: MouseEvent | PointerEvent) => void};

	_cmElem: HTMLElement;

	_clickData: {
		type: "poi" | "custom" | "none";
		data: any;
	};

	_cards: Array<HTMLElement>;

	constructor(scene) {
		super(scene, WASMVisualiser);

		this._dom = {
			scene: document.getElementById("scene"),
			container: document.getElementById("wasm"),
			canvas: document.createElement("canvas"),
		};
		this._dom.canvas.classList.add("wasm-canvas");
		this._map = null;
		this._content = null;
		this._hoverEl = null;
		this._lastHoverEl = null;

		this._historyReplace = debounce(() => {
			Mapy.getComponent("history")?.save(true);
		}, 800);
		this._updatePos = debounce(() => {
			if (!this._map) {
				return;
			}

			const wgs84 = this._map.getPositionWgs();

			store.dispatch(setCoordinates({
				longitude: wgs84.x,
				latitude: wgs84.y,
				zoom: Math.round(this._map.getZoom()),
				ignore: true,
			}));

			this.makeEvent("map-redraw");
			this._historyReplace();
		}, 333);
		this._mapClickListener = null;
		this._dropClick = () => {};
		this._binds = {
			mouseContextMenu: (event: MouseEvent) => {
				this._mouseContextMenu(event);
			},
		};
		this._cmElem = null;
		this._clickData = {
			type: "none",
			data: null,
		};
		this._cards = [];
	}

	/**
	 * Presenter pro 3d.
	 * @return {Melown3d}
	 */
	getMap() {
		return this._map;
	}

	getContent() {
		return this._content;
	}

	/**
	 * Bind signalu nad providerem - nabindujeme si vystup signalu na handleSignal.
	 *
	 * @param  {String} name Nazev signalu
	 */
	addListener(name) {
	}

	/**
	 * Odstraneni poslouchani na nazev signalu - vola scena.
	 *
	 * @param  {String} name Nazev signalu
	 */
	removeListener(name) {
	}

	/**
	 * Nastaveni callback funkce pro kliknuti do mapy.
	 *
	 * @param {Function} cb Callback funkce
	 */
	setMapClick(cb) {
		//console.log(["setMapClick", cb]);
		this._mapClickListener = cb;
	}

	/**
	 * Nastav kurzor provideru.
	 *
	 * @param {String} cursor Styl pro kurzor
	 */
	setCursor(cursor) {
		//console.log(["setCursor", cursor]);
		this._dom.container.style.cursor = cursor || "default";
	}

	/**
	 * Ziskani objektu s paddingem - jak mapa, tak 3d
	 *
	 * @return {Object}
	 */
	getPadding() {
		let dirs = ["left", "right", "top", "bottom"];
		let output = {};

		dirs.forEach(dir => {
			output[dir] = 0;
		});

		return output as { left: number; right: number; top: number; bottom: number; };
	}

	/**
	 * Ziskani DOMu pro obal vrstvy. Neda se bohuzel udelat jinak, pouziti pouze na starem userwebu!
	 *
	 * @return {Element}
	 */
	getLayerMarkerContainer() {
		return document.createElement("div");
	}

	screenPosToMapPos(posX: number, posY: number) {
		if (!this._map) {
			return [0, 0];
		}

		const merc = this._map.screenPosToMapPos({
			x: posX,
			y: posY,
		});

		return merc;
	}

	/**
	 * Nastav stred projekce providera.
	 *
	 * @param {SceneCoords} center
	 */
	setCenter(center) {
		this._map?.setPositionWgs({
			x: center.x,
			y: center.y
		});
		// nastavime zpetne
		store.dispatch(setCoordinates({
			longitude: center.x,
			latitude: center.y,
			ignore: true,
		}));
	}

	/**
	 * Nastav stred a zoom projekce providera.
	 *
	 * @param {SceneCoords} center
	 * @param {Number} [zoom] Volitelny zoom
	 * @param {Boolean} [noAnim = false] Neanimovat?
	 * @param {Object} options nasatveni zoomu
	 * @param {Object} options.maxAnimZoomPlus nasatveni maximalniho rozdilu pro animaci pri zvetsovani zoomu
	 * @param {Object} options.maxAnimZoomMinus nasatveni maximalniho rozdilu pro animaci pri zmensovani zoomu
	 * @return {JAK.Promise}
	 */
	setCenterZoom(center, zoom) {
		//console.log(["setCenterZoom", center, zoom, noAnim, options]);
		const wgs84 = this._map.getPositionWgs();
		const curZoom = this._map.getZoom();

		if (Math.abs(center.x - wgs84.x) <= 0.001 && Math.abs(center.y - wgs84.y) <= 0.001 && Math.abs(curZoom - zoom) === 1) {
			if (curZoom < zoom) {
				this._map?.zoomIn();
			} else {
				this._map?.zoomOut();
			}

			// nastavime novy zoom
			store.dispatch(setCoordinates({
				zoom,
				ignore: true,
			}));

			return Promise.resolve({});
		}

		this._map?.setPositionWgs({
			x: center.x,
			y: center.y
		});
		this._map?.setZoom(zoom);
		// nastavime zpetne
		store.dispatch(setCoordinates({
			longitude: center.x,
			latitude: center.y,
			zoom,
			ignore: true,
		}));

		return Promise.resolve({});
	}

	setPosition(pos) {
		this._map?.setPositionWgs({
			x: pos.x,
			y: pos.y
		});
		this._map?.setZoom(pos.z);
		// nastavime zpetne
		store.dispatch(setCoordinates({
			longitude: pos.x,
			latitude: pos.y,
			zoom: pos.z,
			ignore: true,
		}));
	}

	clearAllWasmContent() {
		this._visualiser?.clearAllWasmContent();
	}

	reload() {
		return Promise.resolve();
	}

	/**
	 * Obal pro zavolani eventu nad scenou. Pokud se jedna o nepodporovany signal, nic se nestane.
	 *
	 * @param  {String} name Nazev signalu
	 * @param  {Object} [data = null] Vlastni data
	 * @param  {SceneFeature} [sender] Kdo to volal?
	 */
	makeEvent(name, data?, sender?) {
		this._scene.makeEvent(name, data, sender);
	}

	setMapset(name: string) {
		//console.log(["set mapset", name]);
		let styleSetId = "d_base";
		// night
		const variant = "";

		switch (name) {
			case "zakladni":
				styleSetId = "d_base";
				break;
			case "turisticka":
				styleSetId = "a_default";
				break;
			case "zimni":
				styleSetId = "b_winter";
				break;
			case "dopravni":
				styleSetId = "e_traffic";
				break;
			case "letecka":
				styleSetId = "c_ophoto";
				break;
		}

		const styleSet = new window.Module.StyleSetCfg(styleSetId, variant);

		this._map?.setStyleSet(styleSet);
	}

	/**
	 * Aktivace provideru.
	 *
	 * @param  {Object} state Aktualni stav sceny
	 * @return {JAK.Promise}
	 */
	_activate() {
		return new Promise(async(resolve, reject) => {
			// udalosti
			this._bindEvents();

			// modul od Petra Slivy
			window.Module = {
				preRun: [],
				postRun: [],
				printErr: text => {
					console.error(text);
				},
				setStatus: text => {
					//console.log(["setStatus", text]);
				},
				monitorRunDependencies: left => {
					//console.log(["monitorRunDependencies", left]);
				},
				onRuntimeInitialized: () => {
					//console.log(["onRuntimeInitialized"]);
					this._build();
					resolve({});
				}
			};

			await Mapy.Util.loadScript("/wasm/lib-maps.js");
		});
	}

	/**
	 * Deaktivace provideru.
	 *
	 * @return {JAK.Promise}
	 */
	_deactivate() {
		this._dom.container.innerHTML = "";

		return Promise.resolve();
	}

	_resize() {
		this._setSize();
	}

	_widthChange() {
		this._setSize();
	}

	_setSize(dpiScale = window.devicePixelRatio) {
		const width = this._dom.scene.offsetWidth;
		const height = this._dom.scene.offsetHeight;

		console.log(`Dpi ${dpiScale}`);

		this._dom.canvas.style.width = `100%`;
		this._dom.canvas.style.height = `100%`;
		this._dom.canvas.width = width * dpiScale;
		this._dom.canvas.height = height * dpiScale;

		this._map?.setHostSize(width, height);
		this._map?.setRenderResolution(this._dom.canvas.width, this._dom.canvas.height);
	}

	_build() {
		this._dom.container.innerHTML = "";

		this._dom.container.appendChild(this._dom.canvas);

		Object.assign(this._dom.canvas.style, {
			position: "absolute",
			left: 0,
			top: 0,
		});

		try {
			const devicePixelRatio = window.devicePixelRatio;

			this._map = new window.Module.MapControl(devicePixelRatio);
			// todo el selektor
			this._map.connectToCanvas("canvas.wasm-canvas");
			this._map.loadStyles('styles/', () => {});
			this._map.setCustomPoiIconResolver(new window.Module.PoiAdminCache('https://vectmap.atc.cz/rpc/'));

			// initialize map cotent service
			this._initMapContentService(this._map.getContentService());

			this._setSize(devicePixelRatio);

			const state = store.getState().map;

			this._map.setPositionWgs({ x: state.longitude, y: state.latitude });
			this._map.setZoom(state.zoom);

			addListener(this, "resize", "_resize");
			addListener(this, "width-change", "_widthChange");

			const { mapset } = store.getState().map;

			this.setMapset(mapset);

			// vyjimka a smrt
			this._map.onMapViewChanged = () => {
				console.log("map view changed");
			};
		} catch (exc) {
			console.log(exc);

			const elem = document.createElement("p");

			Object.assign(elem.style, {
				position: "fixed",
				left: "35%",
				top: "50%",
				border: "3px solid #666",
				padding: "10px",
				textAlign: "center",
				color: "#c01",
				background: "#fff",
				zIndex: "1000",
			});
			elem.innerHTML = exc.toString();
			document.body.append(elem);
		}

		window.requestAnimationFrame(timestamp => {
			this._tick(timestamp);
		});
	}

	_tick(timestamp) {
		this._map?.update(timestamp);

		window.requestAnimationFrame(timestamp => {
			this._tick(timestamp);
		});
	}

	_bindEvents() {
		let startEvent: PointerEvent = null;

		function isClick(beginEvent: PointerEvent, endEvent: PointerEvent) {
			if (beginEvent && endEvent) {
				const dist = Math.sqrt((endEvent.clientX - beginEvent.clientX) ** 2 + (endEvent.clientY - beginEvent.clientY) ** 2);

				return dist < 3;
			}

			return false;
		}

		this._dom.canvas.addEventListener("pointerdown", (event: PointerEvent) => {
			this._map?.onMouseDown(event.offsetX, event.offsetY);
			startEvent = event;
			this._clickData.type = "none";
			this._clickData.data = null;
		}, false);
		this._dom.canvas.addEventListener("pointermove", event => {
			const oldHoverEl = this._hoverEl;

			if (this._lastHoverEl && this._hoverEl && this._hoverEl.elementId !== this._lastHoverEl.elementId) {
				this._clearCards();
				this._lastHoverEl.elementUserData.leave({});
			}

			this._hoverEl = null;

			event.buttons && this._map?.onMouseMove(event.offsetX, event.offsetY);
			!event.buttons && this._map?.onHover(event.offsetX, event.offsetY);

			let isEnter = false;

			if (!this._mapClickListener){
				this.setCursor(this._hoverEl ? "pointer" : "default");

				if (this._hoverEl && !oldHoverEl || this._hoverEl && oldHoverEl) {
					isEnter = true;
				}
			}

			if (isEnter) {
				if (this._lastHoverEl && this._hoverEl.elementId === this._lastHoverEl.elementId) {

				} else {
					if (this._lastHoverEl && this._hoverEl.elementId !== this._lastHoverEl.elementId) {
						this._lastHoverEl.elementUserData.leave({});
						this._clearCards();
					}

					this._hoverEl.elementUserData.enter({});

					if (this._hoverEl.elementUserData.poiData) {
						if (!this._hoverEl.elementUserData.card) {
							description([{ id: this._hoverEl.elementUserData.poiData.id, source: this._hoverEl.elementUserData.poiData.source }]).then(data => {
								if (!this._hoverEl) {
									return;
								}

								const card = this._getCard({
									...this._hoverEl.elementUserData.poiData,
									...data.poi.length
										? data.poi[0]
										: {},
								});
								card.el.classList.add("wasm-card");
								card.el.style.position = "absolute";
								this._hoverEl.elementUserData.card = card;

								const mercCoords = Scene.coordsFromWGS84(this._hoverEl.elementUserData.poiData.mark.lon, this._hoverEl.elementUserData.poiData.mark.lat).toMercator();
								const canvasPos = this._map.mapPosToScreenPos({ x: mercCoords[0], y: mercCoords[1] });

								this._hoverEl.elementUserData.card.el.style.left = `${canvasPos.x}px`;
								this._hoverEl.elementUserData.card.el.style.top = `${canvasPos.y}px`;
								this._hoverEl.elementUserData.card.el.style.transform = "translateX(-50%) translateY(-130%)";
								this._cards.push(card.el);
								this._dom.scene.append(this._hoverEl.elementUserData.card.el);
							});
						}
					}

					this._lastHoverEl = this._hoverEl;
				}
			} else {
				this._lastHoverEl = null;
			}
		}, false);
		this._dom.canvas.addEventListener("pointerup", (event: PointerEvent) => {
			this._map?.onMouseUp();

			if (this._map && isClick(startEvent, event)) {
				if (event.button === 2) {
					this._contextMenu(event);
				} else if (this._mapClickListener) {
					this._mapClickListener.mapClick(event, null);
				} else if (Mapy.getComponent("route").isActive() && (event.ctrlKey || event.metaKey)) {
					Mapy.getComponent("route").mapClick(event);
				}
			}

			this._updatePos();
			startEvent = null;
		}, false);
		// dame na cely dokument
		document.addEventListener("contextmenu", (event: MouseEvent) => {
			event.stopPropagation();
			event.preventDefault();
		});
		this._dom.canvas.addEventListener("wheel", event => {
			// default in pixels
			let divider = 120.0;

			if (event.deltaMode == 1 /* pages */) {
				divider = 3;
			}

			this._map?.onMouseWheel(event.offsetX, event.offsetY, (event.deltaY / divider) / 4);
			this._updatePos();
		}, false);
	}

	_onPoisSelected() {
		if (!this._clickData.data) return;

		const selPoi = this._clickData.data.poiData;
		const source = selPoi.source;
		const id = selPoi.id;

		Mapy.getComponent("layout").setWidth(1);

		if (Mapy.getComponent("detail").isActive() && Mapy.getComponent("gpx").isActive()) {
			Mapy.getComponent("detail").deactivate();
		}

		Mapy.getComponent("detail").activate().setState({
			source,
			id,
			manual: true,
			show: false,
			search: Mapy.getComponent("detail").getSuggestConf()
		}).then(() => {
			Mapy.getComponent("history").save();
		});
	}

	_initMapContentService(contentService) {
		// setup global variable
		this._content = contentService;

		// setul callback which is called when content needs some data from url
		this._content.setRequestDataCallback(async(requestedUrl) => {
			// funstion must download data and set it back to conent service

			// fetch data
			const response = await fetch(requestedUrl);
			const data = await response.arrayBuffer(response);

			// set data back to conent
			this._content.setRequestedData(requestedUrl, new Uint8Array(data));
		});

		// set general on click callback
		this._content.setOnClickCallback(clickData => {
			if (clickData === null) {
				return;
			}

			if (clickData.DataType == window.Module.ActionDataType.Poi) {
				this._clickData.type = "poi";
				this._clickData.data = getUserDataFromPoi(clickData);

				this._onPoisSelected();
			} else if (clickData.DataType == window.Module.ActionDataType.MapElement) {
				this._clickData.type = "custom";
				this._clickData.data = getUserDataFromMapElement(clickData);

				this._clickData.data?.click({});
			}
		});

		this._content.setOnHoverCallback(hoverData => {
			if (hoverData === null) {
				if (this._lastHoverEl) {
					this._clearCards();
					this._lastHoverEl.elementUserData.leave({});
				}

				this._hoverEl = null;
				this._lastHoverEl = null;

				return;
			}

			if (hoverData.DataType == window.Module.ActionDataType.Poi) {
				const data = getUserDataFromPoi(hoverData);

				this._hoverEl = {
					elementId: data.id,
					elementUserData: data,
				};
			} else if (hoverData.DataType == window.Module.ActionDataType.MapElement) {
				const data = getUserDataFromMapElement(hoverData);

				this._hoverEl = {
					elementId: data.id,
					elementUserData: data,
				};
			}
		});

		registerIcons(this._content);
		this._visualiser.runPost();
	}

	_getWasmCard() {
		let WasmCard = function() {};
		WasmCard.prototype = Object.create(Object.assign({}, Mapy.MarkerCard.prototype));

		/**
		 * Bind karty.
		 *
		 * @param  {Element}  el Kam vizitku pripnout?
		 * @param  {Object}  poi Vstupni data pro vizitku. Bude se volat description
		 * @param  {Boolean} [isDetail = false] Jedna se o vizitku pro detail?
		 * @return {Object} Promise s hotovou kartou a callbackem, ktery se vola pri zavreni karty.
		 */
		WasmCard.prototype.bindCard = function(el, poi, isDetail) {
			let output = {
				promise: new JAK.Promise(),
				removeCardCb: () => {}
			};
			let card = {
				getBody: function() {
					return el;
				}
			};

			this._getDesc(poi).then(function(desc) {
				this._setPopupCont(card, desc, isDetail, () => {
					output.removeCardCb();
				});

				output.promise.fulfill();
			}.bind(this), function() {});

			return output;
		}

		return WasmCard;
	}

	/**
	 * Ziskani obsahu vizitky.
	 *
	 * @return {Object} el a promise
	 */
	_getCard(poi) {
		let el = document.createElement("div");
		el.classList.add("card");
		el.classList.add("marker-popup");

		let header = document.createElement("div");
		header.classList.add("card-header");

		let body = document.createElement("div");
		body.classList.add("card-body");

		let footer = document.createElement("div");
		footer.classList.add("card-footer");

		let tail = document.createElement("div");
		tail.classList.add("tail");

		const iconHolder = document.createElement("div");
		const icon = new Image();

		icon.crossOrigin = "anonymous";
		icon.src = getIcon(poi);
		iconHolder.classList.add("wasm-icon-holder");
		iconHolder.classList.add("hide");
		iconHolder.append(icon);

		el.append(iconHolder);
		el.appendChild(header);
		el.appendChild(body);
		el.appendChild(footer);
		el.appendChild(tail);

		const wasmCardConstr = this._getWasmCard();
		const wasmCard = new wasmCardConstr();
		let cardObj = wasmCard.bindCard(body, poi, false);
		cardObj.removeCardCb = () => {
			el.remove();
		};
		cardObj.promise.then(() => {
			iconHolder.classList.remove("hide");
		});

		return {
			el: el,
			promise: cardObj.promise
		};
	}

	_contextMenu(event) {
		// je otevreno - zavreme
		const route = Mapy.getComponent("route");
		const merc = this.screenPosToMapPos(event.offsetX, event.offsetY);
		const coords = Scene.coordsFromMercator(merc.x, merc.y);

		let el = document.createElement("div");
		el.classList.add("context-menu");
		el.style.borderTopLeftRadius = "0";
		el.style.left = event.clientX + "px";
		el.style.top = event.clientY + "px";

		document.addEventListener("mousedown", this._binds.mouseContextMenu);

		let contextRouteFrom = document.createElement("a");
		contextRouteFrom.classList.add("item");
		contextRouteFrom.href = "#";
		contextRouteFrom.innerHTML = _("route.contextRouteFrom");
		contextRouteFrom.addEventListener("click", e => {
			Mapy.Route3.Utils.getPOI(coords).then(poi => {
				let items = Mapy.CML.state.route.items;
				items.unshift(poi);
				if (!route.isActive()) {
					route.activate();
				}
				Mapy.CML.state = {
					route: {
						items
					}
				};
				Mapy.getComponent("history").save();
			}, () => {});
			this._removeCard();
		});

		let contextRouteTo = document.createElement("a");
		contextRouteTo.classList.add("item");
		contextRouteTo.href = "#";
		contextRouteTo.innerHTML = _("route.contextRouteTo");
		contextRouteTo.addEventListener("click", e => {
			Mapy.Route3.Utils.getPOI(coords).then(poi => {
				let items = Mapy.CML.state.route.items;
				poi.position = Mapy.Route3.Const.position.end;
				items.push(poi);
				if (!route.isActive()) {
					route.activate();
				}
				Mapy.CML.state = {
					route: {
						items
					}
				};
				Mapy.getComponent("history").save();
			}, () => {});
			this._removeCard();
		});

		let sep = document.createElement("span");
		sep.classList.add("item");
		sep.classList.add("separator");

		let whereAmI = document.createElement("a");
		whereAmI.classList.add("item");
		whereAmI.href = "#";
		whereAmI.innerHTML = _("whereAmI");
		whereAmI.addEventListener("click", e => {
			getLocation(coords).then(data => {
				Mapy.getComponent("detail").activate().setState({
					source: data.source,
					id: data.id,
					coords,
					gpsCoords: data.gpsCoords,
					manual: true,
					show: false
				}).then(() => {
					Mapy.getComponent("history").save();
				}, () => {});
			});

			this._removeCard();
		});

		el.appendChild(contextRouteFrom);
		el.appendChild(contextRouteTo);
		el.appendChild(sep);
		el.appendChild(whereAmI);

		this._dom.container.append(el);
		this._cmElem = el;
	}

	_mouseContextMenu(event: MouseEvent) {
		if (!this._cmElem?.contains(event.target)) {
			this._removeCard();
		}
	}

	_removeCard() {
		document.removeEventListener("mousedown", this._binds.mouseContextMenu);

		this._cmElem && this._cmElem.remove();
		this._cmElem = null;
	}

	_clearCards() {
		while (this._cards.length) {
			const card = this._cards.pop();

			card.remove();
		}
	}
}
